import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Building2 } from 'lucide-react';

export default function ImpressumPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-white">
      <nav className="bg-white/80 backdrop-blur-xl border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img 
              src="/logo.png" 
              alt="UniSide Logo" 
              className="w-10 h-10 object-contain"
            />
            <span className="text-2xl font-bold font-outfit">UniSide</span>
          </div>
          <Button
            onClick={() => navigate('/')}
            variant="ghost"
            className="rounded-full"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück
          </Button>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-4 py-12">
        <Card className="border-slate-100 shadow-sm rounded-2xl">
          <CardHeader>
            <div className="flex items-center gap-3">
              <Building2 className="w-8 h-8 text-primary" />
              <CardTitle className="text-3xl font-outfit">Impressum</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="prose prose-slate max-w-none">
            <h3 className="text-xl font-semibold mt-6 mb-3">Angaben gemäß § 5 TMG</h3>
            <p>
              <strong>Verein ZORO</strong><br />
              Liese-Prokop-Gasse 7/1<br />
              3452 Heiligeneich<br />
              Österreich
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Vertreten durch</h3>
            <p>
              Vorstand: Fr. Sabine Novotny<br />
              ZVR-Zahl: 211845752
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Kontakt</h3>
            <p>
              Telefon: +43/699 17070547<br />
              E-Mail: leitung@zoro-verein.at
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Auszeichnungen</h3>
            <p>
              Verein ZORO wurde mit dem <strong>Dorothea Neff Award</strong> für besonderes soziales 
              Engagement und Innovation ausgezeichnet.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Haftungsausschluss</h3>
            
            <h4 className="text-lg font-semibold mt-4 mb-2">Haftung für Inhalte</h4>
            <p>
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
            </p>

            <h4 className="text-lg font-semibold mt-4 mb-2">Haftung für Links</h4>
            <p>
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen 
              Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Urheberrecht</h3>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen 
              dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede 
              Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen 
              Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
